import ErrorHandlerProvider from './ErrorHandlerProvider';

export default ErrorHandlerProvider;
